import styled from 'styled-components';

import StyledCheckmark from './StyledCheckmark';

import theme from '$/assets/theme';

const StyledInput = styled.input`
  display: none;

  &:checked ~ ${StyledCheckmark} {
    background: ${theme.colors.grey8};

    &:after {
      opacity: 1;
    }
  }
`;

export default StyledInput;
